/*
 * Scroll-to-top widget.
 *
 * One rAF-throttled scroll listener toggles `.is-visible` on the button
 * once the page scroll passes the merchant-configured threshold (default
 * 300px). Click smooth-scrolls to top via `scrollTo({ behavior: 'smooth' })`
 * — respects `prefers-reduced-motion` (CSS handles the visual side; the
 * smooth-scroll behavior degrades to instant for users who opted out via
 * `window.matchMedia('(prefers-reduced-motion: reduce)')` below).
 */
(function () {
  'use strict';

  function init(btn) {
    if (!btn || btn.dataset.devSttInit === '1') return;
    btn.dataset.devSttInit = '1';

    var threshold = parseInt(btn.dataset.threshold, 10);
    if (isNaN(threshold) || threshold < 0) threshold = 300;

    var ticking = false;
    var prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function update() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;
      if (y > threshold) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    btn.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // Initial check — page may load already scrolled past the threshold.
    update();
  }

  function boot() {
    document
      .querySelectorAll('[data-dev-scroll-to-top]')
      .forEach(function (el) {
        init(el);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the section is reloaded in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector
      ? e.target.querySelector('[data-dev-scroll-to-top]')
      : null;
    if (el) init(el);
  });
})();
